<template>
  <div class="row h-100">
    <div class="col-12" v-for="(card, index) in cards" :key="index">
      <div class="card card-small">
        <div class="card-body position-relative">
          <div
            v-if="card.showTooltip"
            class="info"
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            title="The value calculated based on schedule for this month"
          >
            i
          </div>
          <div class="widget-content">
            <div class="image">
              <img :src="require(`@/assets/images/icon/${card.img}.png`)" />
            </div>
            <div>
              <h4 class="title" v-html="titleHTML(card)"></h4>
              <span class="subtitle">{{ card.subtitle }}</span>
            </div>
          </div>
        </div>
        <div v-if="card.value" class="card-footer">
          <span>See All Streetlights >></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tooltip } from "bootstrap/dist/js/bootstrap.esm.min.js";
export default {
  props: ["cards"],
  data() {
    return {
      // cards: [
      //   {
      //     img: "status",
      //     title: "Online",
      //     subtitle: "Last Hour\nCluster Status",
      //   },
      //   {
      //     img: "uprate",
      //     title: "95.5%",
      //     subtitle: "Communication\nUprate",
      //   },
      //   {
      //     img: "schedule",
      //     title: "Weekdays",
      //     subtitle: "Schedule Profile",
      //   },
      // ],
    };
  },
  methods: {
    titleHTML(card) {
      if (!card) return;
      if (card.img !== "status") {
        return `<strong>${card.title}</strong>`;
      }
      return `<p style="color: ${
        card.title === "Online" ? "#009A78" : "#FFAE2C"
      }">${card.title}</p>`;
    },
  },
  mounted() {
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    });
  },
  unmounted() {
    let popovers = document.getElementsByClassName("tooltip");
    popovers.forEach((item) => {
      item.remove();
    });
  },
};
</script>